import * as yup from "yup";

// Validation schema for the admin user form
// Helper to normalize empty strings to null for optional text fields
const emptyToNull = (v) => (v === "" ? null : v);

export const userValidationSchema = yup.object({
  rolle: yup.string().required("Bitte wählen Sie eine Rolle aus."),
  status: yup.string().required("Bitte wählen Sie einen Status aus."),
  kunde_id: yup.mixed().when("rolle", {
    is: (rolle) =>
      rolle !== "sysadmin" &&
      rolle !== "accredo" &&
      rolle !== "accredo_buchungsexport",
    then: () => yup.mixed().required("Bitte wählen Sie einen Kunden aus."),
    otherwise: () => yup.mixed().nullable(),
  }),
  email: yup
    .string()
    .email("Bitte geben Sie eine gültige E-Mail-Adresse ein.")
    .required("E-Mail ist erforderlich."),
  telefon: yup.string().nullable().transform(emptyToNull),
  fax: yup.string().nullable().transform(emptyToNull),
  anrede: yup.string().nullable().transform(emptyToNull),
  titel: yup.string().nullable().transform(emptyToNull),
  vorname: yup.string().required("Vorname ist erforderlich."),
  nachname: yup.string().required("Nachname ist erforderlich."),
  strasse: yup.string().nullable().transform(emptyToNull),
  plz: yup.string().nullable().transform(emptyToNull),
  ort: yup.string().nullable().transform(emptyToNull),
  rpp: yup.string(),
  level_benachrichtigung: yup.string(),
});

// Default values for the form
export const userDefaultValues = {
  rolle: "",
  status: "aktiv",
  kunde_id: null,
  email: "",
  telefon: "",
  fax: "",
  anrede: "",
  titel: "",
  vorname: "",
  nachname: "",
  strasse: "",
  plz: "",
  ort: "",
  rpp: "5",
  level_benachrichtigung: "taeglich",
};

// Options for select fields
export const userOptions = {
  rolle: [
    { key: "sysadmin", label: "Systemadministrator" },
    { key: "accredo", label: "Interner Mitarbeiter" },
    {
      key: "accredo_buchungsexport",
      label: "Interner Mitarbeiter (Buchungsexport)",
    },
    { key: "kd_verwaltung", label: "Kunde (Verwaltung)" },
    { key: "kd_controlling", label: "Kunde (Controlling)" },
    { key: "kd_aussendienst", label: "Kunde (Aussendienst)" },
    {
      key: "kd_kundenportal_eingeschraenkt",
      label: "Kunde Kundenportal (eingeschränkt)",
    },
    {
      key: "kd_eingeschraenkt",
      label: "Kunde (Aussendienst eingeschränkt)",
    },
  ],
  status: [
    { key: "aktiv", label: "aktiv" },
    { key: "inaktiv", label: "inaktiv (Nutzer kann sich nicht anmelden)" },
    { key: "gesperrt", label: "gesperrt (Passwort vergessen möglich)" },
  ],
  anrede: [
    { key: "Herr", label: "Herr" },
    { key: "Frau", label: "Frau" },
  ],
  rpp: [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "20", label: "20" },
    { key: "25", label: "25" },
    { key: "30", label: "30" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
  ],
  level_benachrichtigung: [
    {
      key: "einzeln",
      label: "einzeln",
      detail: "Sie erhalten für jede Aktualisierung eine separate E-Mail.",
    },
    {
      key: "taeglich",
      label: "täglich",
      detail:
        "Bei Aktualisierungen erhalten Sie einmal am Tag eine Zusammenfassung per E-Mail.",
    },
    {
      key: "keine",
      label: "keine",
      detail:
        "Das Schadenportal sendet Ihnen keine E-Mails. Sie sollten sich deshalb regelmäßig im Schadenportal anmelden um keine Aktualisierung zu verpassen.",
    },
  ],
};

// API endpoints for fetching data
export const optionsApiEndpoints = {
  kundeOptions: "data/kundes_select?id_type=internal",
};

// Helper function to check if a field should be disabled based on the role
export const isFieldDisabledByRole = (fieldName, role) => {
  if (fieldName === "kunde_id") {
    return (
      role === "sysadmin" ||
      role === "accredo" ||
      role === "accredo_buchungsexport"
    );
  }

  return false;
};

const CUSTOMER_ROLE_KEYS = [
  "kd_verwaltung",
  "kd_controlling",
  "kd_aussendienst",
  "kd_eingeschraenkt",
  "kd_kundenportal_eingeschraenkt",
];

// Customer admins may only assign customer roles, never tenant roles
export const getRoleOptions = (isCustomerAdmin) =>
  isCustomerAdmin
    ? userOptions.rolle.filter((option) =>
        CUSTOMER_ROLE_KEYS.includes(option.key)
      )
    : userOptions.rolle;

